import React from 'react';

const NotFound = () => {
    return (
        <div className='min-h-screen'>
            <img src="https://i.ibb.co/pZf2K7j/404-error-page-templates.jpg" alt="" />
        </div>
    );
};

export default NotFound;